import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared.module';
import {AuthRoutingModule} from './auth-routing.module';
import {AngularFireAuthModule} from '@angular/fire/compat/auth';
import {LoginComponent} from './components/login/login.component';
import {ContactUsComponent} from './components/contact-us/contact-us.component';
import {SignUpComponent} from './components/signup/signup.component';

@NgModule({
  declarations: [SignUpComponent, LoginComponent, ContactUsComponent],
  imports: [
    ReactiveFormsModule,
    AngularFireAuthModule,
    SharedModule,
    AuthRoutingModule,
    // RecaptchaV3Module,
    //  EffectsModule.forFeature([AuthEffects]),
  ],
  // providers: [
  //   { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6LdX9nUaAAAAADBsCMwEF5EDAEqcIAimkzCsGnyK' }
  // ]
})
export class AuthModule {}
